import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Box from '@material-ui/core/Box';
import Image from 'base/components/Image';
import GradientOverlay from 'base/ui_components/GradientOverlay';
import { getImageWithHeight } from 'utils/images';

const styles = theme => ({
  gradientOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background:
      'linear-gradient(180deg, rgba(86,86,86,0.57) 0%, rgba(216,216,216,0) 100%)'
  },
  imageContainer: {
    position: 'relative',
    width: '100%'
  }
});

class MenuItemImage extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    classes: PropTypes.object
  };

  render() {
    const { src, classes } = this.props;
    const resizedImage = getImageWithHeight(src, 520);
    return (
      <Box height="260px" className={classes.imageContainer}>
        <Image gradientId="menu-item-image" src={resizedImage} />
        <GradientOverlay height="110px" />
      </Box>
    );
  }
}

export default withStyles(styles)(MenuItemImage);
